<script>
	import { onMount } from "svelte";
    import RegularHexagon from "./RegularHexagon.svelte";
	import BroCastHex from "./BroCastHex.svelte";
    import ZwaarLogo from "./ZwaarLogo.svelte";
    import AgeOfGoldHex from "./AgeOfGoldHex.svelte";
    import TeamHex from "./TeamHex.svelte";
    import GithubHex from "./GithubHex.svelte";
    import ContactHex from "./ContactHex.svelte";
    import HexPlaceHex from "./HexPlaceHex.svelte";
    import FlutterFlyHex from "./FlutterFlyHex.svelte";
	import ArtHex from "./ArtHex.svelte";

	let disabledScroll = false;

	// A box and corresponding width and height value of the box.
	// The box is set to the full screen width and height 
	// and we observe the box for any changes in the size
	let screenBox;
	let screenWidth = -1;
	let screenHeight = -1;
	let hexSize = -1;

	// The hexagons list has the attributes for the Hexagons and the hex list will hold the objects.
	let hexagons = [];
    let hex = [];
	let innerWidth = 0
    let innerHeight = 0
    $: normalMode = innerWidth*1.33 >= innerHeight;
	var currentMode = normalMode;
	onMount(() => {

		// Adding global styling in the onMount.
		// We do this to disable any and all scrolling on the main page while allowing regular actions on other pages
		document.body.style.touchAction = "none";
		document.body.style.overflow = "hidden";
		document.body.style.height = "100%";

		const resizeObserver = new ResizeObserver(entries => {
			const entry = entries.at(0);

			screenWidth = entry.contentRect.width;
			screenHeight = entry.contentRect.height;

			if (currentMode != normalMode) {
				currentMode = normalMode;
				setHexagons();
			}

			// The width of a single hexagon is 2 * hexSize but there is overlap
			// 3 hexagons next to each other will be 5 * hexSize in width.
			// We determine the hexSize to be the screen width divided by 20
			// Which means we will need 14 hexagons in the width.
			// So we will create 7 layers
			if (screenWidth > screenHeight) {
				hexSize = screenWidth / 20;
			} else {
				hexSize = screenHeight / 20;
			}
			for (let i = 0; i <= hex.length - 1; i++) {
				hex[i].updateHexagon(hexSize);
			}
			if (zwaarLogo) {
				zwaarLogo.updateHexagon(hexSize, normalMode);
			}
		});
		resizeObserver.observe(screenBox);
		return () => resizeObserver.unobserve(screenBox);
	});

	function setHexagons() {
		hexagons = [];
		// Not the cleanest solution, but we will manually define all the hexagons that we want to display.
		// This gives us full control to the final visual result.
		// We will use the q, r, s coordinates system even though just q, r should be sufficient.
		// It should hold for all hexagons that q + r + s == 0
		// The center hexagon
		hexagons.push([0, 0, 0, ""]);
		// The first layer (6 neighbours of the center)
		hexagons.push([0, -1, 1, ""]);
		hexagons.push([1, -1, 0, ""]);
		
		hexagons.push([1, 0, -1, "brocast"]);
		
		hexagons.push([0, 1, -1, ""]);
		hexagons.push([-1, 1, 0, "age of gold"]);
		
		hexagons.push([-1, 0, 1, ""]);
		// The second layer
		hexagons.push([0, -2, 2, ""]);
		hexagons.push([1, -2, 1, ""]);
		
		hexagons.push([2, -2, 0, "team"]);
		
		hexagons.push([2, -1, -1, ""]);
		hexagons.push([2, 0, -2, "flutter fly"]);
		hexagons.push([1, 1, -2, ""]);
		
		hexagons.push([0, 2, -2, "contact"]);
		
		hexagons.push([-1, 2, -1, ""]);
		hexagons.push([-2, 2, 0, ""]);
		
		hexagons.push([-2, 1, 1, ""]);
		hexagons.push([-2, 0, 2, ""]);   // part of the zwaar logo in normalMode
		hexagons.push([-1, -1, 2, ""]);  // part of the zwaar logo in normalMode
			
		// The third layer
		hexagons.push([0, -3, 3, ""]);  // The top
		hexagons.push([1, -3, 2, ""]);
		hexagons.push([2, -3, 1, "github"]);
		hexagons.push([3, -3, 0, ""]);
		hexagons.push([3, -2, -1, ""]);

		hexagons.push([3, -1, -2, ""]);

		hexagons.push([3, 0, -3, ""]);
		hexagons.push([2, 1, -3, ""]);
		hexagons.push([1, 2, -3, ""]);
		hexagons.push([0, 3, -3, ""]);  // The bottom
		hexagons.push([-1, 3, -2, ""]);

		hexagons.push([-2, 3, -1, "hex place"]);

		hexagons.push([-3, 3, 0, ""]);
		
		hexagons.push([-3, 2, 1, ""]);
		hexagons.push([-3, 1, 2, ""]);
		hexagons.push([-3, 0, 3, ""]);
		hexagons.push([-2, -1, 3, ""]);
		hexagons.push([-1, -2, 3, ""]);
		// The fourth layer
		hexagons.push([0, -4, 4, ""]);  // The top
		hexagons.push([1, -4, 3, ""]);  // next to the top
		hexagons.push([2, -4, 2, ""]);  // next to the top
		hexagons.push([3, -4, 1, "art"]);
		hexagons.push([4, -4, 0, ""]);
		hexagons.push([4, -3, -1, ""]);
		hexagons.push([4, -2, -2, ""]);
		hexagons.push([4, -1, -3, ""]);
		hexagons.push([4, 0, -4, ""]);

		hexagons.push([3, 1, -4, ""]);
		
		hexagons.push([2, 2, -4, ""]);  // next to the bottom
		hexagons.push([1, 3, -4, ""]);  // next to the bottom
		hexagons.push([0, 4, -4, ""]);  // The bottom
		hexagons.push([-1, 4, -3, ""]);  // next to the bottom
		hexagons.push([-2, 4, -2, ""]);  // next to the bottom
		hexagons.push([-3, 4, -1, ""]);
		hexagons.push([-4, 4, 0, ""]);
		hexagons.push([-4, 3, 1, ""]);
		hexagons.push([-4, 2, 2, ""]);
		hexagons.push([-4, 1, 3, ""]);
		hexagons.push([-4, 0, 4, ""]);
		hexagons.push([-3, -1, 4, ""]);
		hexagons.push([-2, -2, 4, ""]);  // next to the top
		hexagons.push([-1, -3, 4, ""]);  // next to the top
		// These are the same in normal and mobile mode
		// The fifth layer
		hexagons.push([0, -5, 5, ""]);
		hexagons.push([1, -5, 4, ""]);
		hexagons.push([2, -5, 3, ""]);
		hexagons.push([3, -5, 2, ""]);
		hexagons.push([4, -5, 1, ""]);
		hexagons.push([5, -5, 0, ""]);
		hexagons.push([5, -4, -1, ""]);
		hexagons.push([5, -3, -2, ""]);
		hexagons.push([5, -2, -3, ""]);
		hexagons.push([5, -1, -4, ""]);
		hexagons.push([5, 0, -5, ""]);
		hexagons.push([4, 1, -5, ""]);
		hexagons.push([3, 2, -5, ""]);
		hexagons.push([2, 3, -5, ""]);
		hexagons.push([1, 4, -5, ""]);
		hexagons.push([0, 5, -5, ""]);
		hexagons.push([-1, 5, -4, ""]);
		hexagons.push([-2, 5, -3, ""]);
		hexagons.push([-3, 5, -2, ""]);
		hexagons.push([-4, 5, -1, ""]);
		hexagons.push([-5, 5, 0, ""]);
		hexagons.push([-5, 4, 1, ""]);
		hexagons.push([-5, 3, 2, ""]);
		hexagons.push([-5, 2, 3, ""]);
		hexagons.push([-5, 1, 4, ""]);
		hexagons.push([-5, 0, 5, ""]);
		hexagons.push([-4, -1, 5, ""]);
		hexagons.push([-3, -2, 5, ""]);
		hexagons.push([-2, -3, 5, ""]);
		hexagons.push([-1, -4, 5, ""]);
		// The sixth layer
		hexagons.push([0, -6, 6, ""]);
		hexagons.push([1, -6, 5, ""]);
		hexagons.push([2, -6, 4, ""]);
		hexagons.push([3, -6, 3, ""]);
		hexagons.push([4, -6, 2, ""]);
		hexagons.push([5, -6, 1, ""]);
		hexagons.push([6, -6, 0, ""]);
		hexagons.push([6, -5, -1, ""]);
		hexagons.push([6, -4, -2, ""]);
		hexagons.push([6, -3, -2, ""]);
		hexagons.push([6, -2, -4, ""]);
		hexagons.push([6, -1, -5, ""]);
		hexagons.push([6, 0, -6, ""]);
		hexagons.push([5, 1, -6, ""]);
		hexagons.push([4, 2, -6, ""]);
		hexagons.push([3, 3, -6, ""]);
		hexagons.push([2, 4, -6, ""]);
		hexagons.push([1, 5, -6, ""]);
		hexagons.push([0, 6, -6, ""]);
		hexagons.push([-1, 6, -5, ""]);
		hexagons.push([-2, 6, -4, ""]);
		hexagons.push([-3, 6, -3, ""]);
		hexagons.push([-4, 6, -2, ""]);
		hexagons.push([-5, 6, -1, ""]);
		hexagons.push([-6, 6, 0, ""]);
		hexagons.push([-6, 5, 1, ""]);
		hexagons.push([-6, 4, 2, ""]);
		hexagons.push([-6, 3, 3, ""]);
		hexagons.push([-6, 2, 4, ""]);
		hexagons.push([-6, 1, 5, ""]);
		hexagons.push([-6, 0, 6, ""]);
		hexagons.push([-5, -1, 6, ""]);
		hexagons.push([-4, -2, 6, ""]);
		hexagons.push([-3, -3, 6, ""]);
		hexagons.push([-2, -4, 6, ""]);
		hexagons.push([-1, -5, 6, ""]);
		// The seventh layer
		hexagons.push([0, -7, 7, ""]);
		hexagons.push([1, -7, 6, ""]);
		hexagons.push([2, -7, 5, ""]);
		hexagons.push([3, -7, 4, ""]);
		hexagons.push([4, -7, 3, ""]);
		hexagons.push([5, -7, 2, ""]);
		hexagons.push([6, -7, 1, ""]);
		hexagons.push([7, -7, 0, ""]);
		hexagons.push([7, -6, -1, ""]);
		hexagons.push([7, -5, -2, ""]);
		hexagons.push([7, -4, -3, ""]);
		hexagons.push([7, -3, -4, ""]);
		hexagons.push([7, -2, -5, ""]);
		hexagons.push([7, -1, -6, ""]);
		hexagons.push([7, 0, -7, ""]);
		hexagons.push([6, 1, -7, ""]);
		hexagons.push([5, 2, -7, ""]);
		hexagons.push([4, 3, -7, ""]);
		hexagons.push([3, 4, -7, ""]);
		hexagons.push([2, 5, -7, ""]);
		hexagons.push([1, 6, -7, ""]);
		hexagons.push([0, 7, -7, ""]);
		hexagons.push([-1, 7, -6, ""]);
		hexagons.push([-2, 7, -5, ""]);
		hexagons.push([-3, 7, -4, ""]);
		hexagons.push([-4, 7, -3, ""]);
		hexagons.push([-5, 7, -2, ""]);
		hexagons.push([-6, 7, -1, ""]);
		hexagons.push([-7, 7, 0, ""]);
		hexagons.push([-7, 6, 1, ""]);
		hexagons.push([-7, 5, 2, ""]);
		hexagons.push([-7, 4, 3, ""]);
		hexagons.push([-7, 3, 4, ""]);
		hexagons.push([-7, 2, 5, ""]);
		hexagons.push([-7, 1, 6, ""]);
		hexagons.push([-7, 0, 7, ""]);
		hexagons.push([-6, -1, 7, ""]);
		hexagons.push([-5, -2, 7, ""]);
		hexagons.push([-4, -3, 7, ""]);
		hexagons.push([-3, -4, 7, ""]);
		hexagons.push([-2, -5, 7, ""]);
		hexagons.push([-1, -6, 7, ""]);
	}
	setHexagons();

	let colourIntensity = 75;
	let zwaarLogo;
</script>

<main class:scroll-lock={disabledScroll}>
	{#each hexagons as hexagon, i}
		{#if hexagon[3] == "brocast"}
			<BroCastHex q={hexagon[0]} r={hexagon[1]} colourIntensity={colourIntensity} hexSize={hexSize} bind:this={hex[i]}></BroCastHex>
		{:else if hexagon[3] == "team"}
			<TeamHex q={hexagon[0]} r={hexagon[1]} colourIntensity={colourIntensity} hexSize={hexSize} bind:this={hex[i]}></TeamHex>
		{:else if hexagon[3] == "age of gold"}
			<AgeOfGoldHex q={hexagon[0]} r={hexagon[1]} colourIntensity={colourIntensity} hexSize={hexSize} bind:this={hex[i]}></AgeOfGoldHex>
		{:else if hexagon[3] == "github"}
			<GithubHex q={hexagon[0]} r={hexagon[1]} colourIntensity={colourIntensity} hexSize={hexSize} bind:this={hex[i]}></GithubHex>
		{:else if hexagon[3] == "contact"}
			<ContactHex q={hexagon[0]} r={hexagon[1]} colourIntensity={colourIntensity} hexSize={hexSize} bind:this={hex[i]}></ContactHex>
		{:else if hexagon[3] == "hex place"}
			<HexPlaceHex q={hexagon[0]} r={hexagon[1]} colourIntensity={colourIntensity} hexSize={hexSize} bind:this={hex[i]}></HexPlaceHex>
		{:else if hexagon[3] == "flutter fly"}
			<FlutterFlyHex q={hexagon[0]} r={hexagon[1]} colourIntensity={colourIntensity} hexSize={hexSize} bind:this={hex[i]}></FlutterFlyHex>
		{:else if hexagon[3] == "art"}
			<ArtHex q={hexagon[0]} r={hexagon[1]} colourIntensity={colourIntensity} hexSize={hexSize} bind:this={hex[i]}></ArtHex>
		{:else}
			<RegularHexagon q={hexagon[0]} r={hexagon[1]} colourIntensity={colourIntensity} hexSize={hexSize} bind:this={hex[i]}></RegularHexagon>
		{/if}
	{/each}
	<ZwaarLogo colourIntensity={colourIntensity} hexSize={hexSize} bind:this={zwaarLogo}></ZwaarLogo>

	<div class="intensity_slider">
		<p class="intensity_slider_text">Colour intensity: {colourIntensity}</p>
		<input bind:value={colourIntensity} type="range" min="0" max="255" />
	</div>


	<!-- Width is {screenWidth}px  Height is {screenHeight}px -->
	<div class="screen_box" bind:this={screenBox}></div>
</main>

<svelte:window on:wheel|nonpassive|preventDefault bind:innerWidth bind:innerHeight/>

<style>

	.intensity_slider_text {
		color: white;
		font-size: 16px;
		/* create an outline using the shadow styling */
		text-shadow:
			-1px -1px 0 #000,
			1px -1px 0 #000,
			-1px 1px 0 #000,
			1px 1px 0 #000;  
	}

	.intensity_slider {
		position: absolute;
	}

	main {
		font-family: sans-serif;
		text-align: center;
	}

	.screen_box {
		background-color: #131619;
		width: 100vw;
		height: 100vh;
	}
</style>